import React from "react";

const CELL_STYLE = { fontSize: "1em", lineHeight: "1.49em" };

/** Paging footer shared by the EFT / Check / Debit payment reports. */
export default function PaymentReportPagination({ data, offset, limit, setitems, pageBack, pageForward, rowsKey = "providerreports" }) {
    const rows = data ? data[rowsKey] : null;
    return (
        <div className="pages">
            <div className="col-lg-6"></div>
            <div className="col-lg-6">
                <div className="col-lg-4">
                    Items per page:{" "}
                    <select onChange={(e) => setitems(e.target.value)} name="">
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
                <div className="col-lg-3">
                    {data ? (rows ? (rows.length == 0 ? 0 : offset + 1) : offset + 1) : offset + 1} -{" "}
                    {data ? (rows ? (rows.length < limit ? rows.length : limit) : limit) : limit} of{" "}
                    {data ? (rows ? rows.length : "") : ""}{" "}
                </div>
                <div className="col-lg-5">
                    <a onClick={pageBack} href="#">
                        <span className="nav-left"></span>
                    </a>
                    <a onClick={pageForward} href="#">
                        <span className="nav-right"></span>
                    </a>
                </div>
            </div>
        </div>
    );
}

/** Column headings shared by the EFT / Check / Debit payment reports. */
export function PaymentReportHeaderRow({ idLabel }) {
    return (
        <tr className="list_header">
            <th align="left" style={CELL_STYLE}>
                Product
            </th>
            <th align="left" style={CELL_STYLE}>
                Patient Name
            </th>
            <th align="left" style={CELL_STYLE}>
                DOB
            </th>
            <th align="center" style={CELL_STYLE}>
                Member Number
            </th>
            <th align="center" style={CELL_STYLE}>
                DOS
            </th>
            <th align="center" style={CELL_STYLE}>
                Payee Info
            </th>
            <th style={{ textAlign: "center", ...CELL_STYLE }}>Amount</th>
            <th style={{ textAlign: "center", ...CELL_STYLE }}>{idLabel}</th>
            <th style={{ textAlign: "center", ...CELL_STYLE }}>Status Date</th>
            <th style={{ textAlign: "center", ...CELL_STYLE }}>Status</th>
        </tr>
    );
}


